import { z } from 'zod'
import { Handles } from '@/types/dashboard/domain/Handles'

// API returns 'handles' (lowercase)
export const DomainDetails = z.object({
  auth_code: z.string().optional(),
  handles: z.object(Handles.shape).optional(),
  linked_to: z.number().int().optional(),
  transfer_lock: z.boolean().optional(),
  whois_protection: z.boolean().optional(),
  trustee_service: z.boolean().optional(),
  nameservers: z.array(z.string()).optional(),
  uses_inwx_ns: z.boolean().optional(),
  is_external: z.boolean().optional(),
  // Set instead of the registrar fields while an inbound transfer is pending.
  transfer_pending: z.boolean().optional(),
  // Unix seconds.
  transfer_started_at: z.number().int().optional()
})

export type DomainDetails = z.infer<typeof DomainDetails>
